module.exports = __webpack_public_path__ + "static/media/notification-loud.dbf5950f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/notification-loud.mp3
// module id = 468
// module chunks = 58